module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAAAcCAIAAAHRoOVkAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAElSURBVEhL7ZVRDoIwDIa5ji8SXzyIhzERExIxvvvkEUy8h0ZvhYMmtQ4GLZRNzJovS9d1/vtxaJKvT9tF7iKhk7Is6dTwtdxkxPJnrV+VdvA+U0rLTiraPCKiqsnhcXtp+4SAnC5R+jVdm70/IUOIncPI0sK3pEEgiV9rx+XgIJPEgCnWIWGi8GADSErxLXneXLxK7pYH3xajHlK9g3VYdREsPZfGAG2Z3khzBq6eFVCkPUwE/mqhKmhRisAfJNYohaWnSNTTxbeeZ3z/AwYhOpw/yg5dP+lYMUlv4C4VNB3i4eCgVmAb9sBIgzZoMYnDjgrA7xzPhA7NFMIq0rE1sFmFqW6pK+FMdQl/S03ualNB0+FvEh3OnCwtkv3qaFX/ifv1+QY+7OMEI+CMDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/til86.png
// module id = HtgM
// module chunks = 1